import React from "react";
import { motion } from "framer-motion";

export default function GiveawayRaffle({ onScrollToForm, loggedIn, config }) {
  return (
    <section
      className="py-20 px-4 relative overflow-hidden"
      style={{ background: "#161616" }}
      dir="rtl"
    >
      {/* Glow blob */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[500px] h-64 pointer-events-none"
        style={{ background: "rgba(200,241,53,0.05)", filter: "blur(80px)", borderRadius: "50%" }} />

      <div className="max-w-2xl mx-auto text-center relative z-10">
        <motion.div initial={{ opacity: 0, y: 16 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }}>

          <p className="text-xs font-black uppercase tracking-widest mb-3" style={{ color: "#c8f135" }}>ועוד לא אמרנו הכל</p>
          <h2 className="font-black mb-4 text-white" style={{ fontSize: "clamp(1.8rem, 4vw, 2.8rem)" }}>
            {config?.heading ?? "אתגר המונדיאל הגדול של Mom3ntum יוצא לדרך!"}
          </h2>

          <p className="text-base leading-relaxed mb-8" style={{ color: "rgba(255,255,255,0.75)" }}>
            {config?.body ?? "אצלנו אתם שולטים בתוצאה לאירוע הספורט הגדול בעולם. בלי הגרלות ובלי אותיות קטנות – מי שמשקיע בקהילה, מרוויח. הירשמו, קחו חלק בפעילות, ואתם עלולים למצוא את עצמכם עם:"}
          </p>

          {/* Prize card */}
          <div className="relative mb-8">
            {/* World Cup trophy image — overlapping top of card */}
            <div className="flex justify-center" style={{ marginBottom: "-48px", position: "relative", zIndex: 2 }}>
              <img
                src="https://media.base44.com/images/public/69b41710d6b60acb7a810a52/2ba56e358_world_cup.png"
                alt="גביע העולם"
                className="w-28 h-28 object-contain drop-shadow-2xl"
                style={{ filter: "drop-shadow(0 8px 24px rgba(200,241,53,0.25))" }}
              />
            </div>

            <div
              className="rounded-2xl pt-16 pb-6 px-6 relative overflow-hidden"
              style={{ background: "#111", border: "1.5px solid rgba(200,241,53,0.3)" }}
            >
              <div className="absolute top-0 left-0 right-0 h-0.5" style={{ background: "linear-gradient(90deg, transparent, #c8f135, transparent)" }} />
              <p className="text-xl font-bold text-white mb-1">{config?.prize_title ?? "זוג כרטיסים למשחק הפתיחה החגיגי"}</p>
              <p className="text-2xl font-bold mb-2" style={{ color: "#c8f135" }}>{config?.prize_subtitle ?? 'ארה"ב 2026!'}</p>
              <p className="text-base" style={{ color: "#c4c4c4" }}>{config?.prize_detail ?? "בשיתוף קשרי תעופה"}</p>
            </div>
          </div>

          {/* Goal section */}
          <div className="mb-8">
            <p className="text-xs font-black uppercase tracking-widest mb-3" style={{ color: "#c8f135" }}>היעד הגדול שלנו</p>
            <p className="text-lg font-bold text-white mb-2">מה מחכה למצטיינים? ההשקעה שלכם משתלמת.</p>
            <p className="text-base leading-relaxed" style={{ color: "rgba(255,255,255,0.75)" }}>
              בלי הגרלות, נטו מאמץ. חבר הקהילה שישלים את מירב המשימות והפעילויות במהלך 10 ימי האתגר — יגדילו את הסיכויים לזוג הכרטיסים למשחק הפתיחה של מונדיאל 2026!
            </p>
          </div>

          <button
            onClick={onScrollToForm}
            className="inline-flex items-center gap-2 font-black text-lg px-10 py-4 rounded-full transition-all duration-200 active:scale-95"
            style={{ background: "#c8f135", color: "#000", boxShadow: "0 8px 28px rgba(200,241,53,0.3)" }}
          >
            {config?.cta_text ?? "קחו אותי למשימה הראשונה"}
          </button>
        </motion.div>
      </div>
    </section>
  );
}